const categoryUrlMap = {
	działanie: 'dzialanie',
	wiedza: 'wiedza'
};

export const getPageUrl = (category, slug) =>
	`/${categoryUrlMap[category]}/${slug}/`;
